import { render, staticRenderFns } from "./FinManFin.vue?vue&type=template&id=32fb836b&scoped=true"
import script from "./FinManFin.vue?vue&type=script&lang=js"
export * from "./FinManFin.vue?vue&type=script&lang=js"
import style0 from "./FinManFin.vue?vue&type=style&index=0&id=32fb836b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fb836b",
  null
  
)

export default component.exports